import { createGlobalStyle } from 'styled-components';
import sfProDisplayRegular from '../assets/font/sfProDisplayRegular.otf';
import sfProDisplayMedium from '../assets/font/sfProDisplayMedium.otf';
import sfProDisplayBold from '../assets/font/sfProDisplayBold.otf';

export const lightTheme = {
  background: '#f9f4ee',
  primary: '#E61E29',
  darkGray: '#4C4C4C',
  lightGray: '#A9A9A9',
  gray: '#f2f2f2',
  white: '#ffffff',
  green: '#0CAD4A',
  yellow: '#F6AE00',
  chipYellow: '#D4A222',
  orange: '#FF9900',
  darkYellow: '#C28831',
  darkBlue: '#172A55',
  transparentBlue: '#E8EAEE',
  transparentGreen: '#E9F8EB',
  transparentRed: '#FFEDED',
  blue: '#0068EE',
  mediumGray: '#e3e3e3',
  aiGradient:
    'linear-gradient(90deg, #306FDE 0%, #3A6BDB 32%, #7F50C7 68%, #BA39B5 100%, #306FDE 100%)',
  sizes: {
    s1: '4',
    s2: '8',
    s3: '12',
    s4: '16',
    s5: '20',
    s6: '24',
    s7: '28',
    s8: '32',
    s9: '36',
    s10: '40',
  },
  shadows: {
    shadow1: '0px 15px 30px rgba(0, 0, 0, 0.1)',
    shadow2: '0px 10px 15px rgba(0, 0, 0, 0.1)',
  },
  borders: {
    border1: '1px solid #e3e3e3',
  },
  transitions: {
    ease300ms: 'all 0.3s ease',
    ease200ms: 'all 0.2s ease',
    ease100ms: 'all 0.1s ease',
  },
  transparency: {
    t10: '1A',
    t15: '26',
    t20: '33',
    t30: '4D',
    t40: '66',
    t50: '80',
    t60: '99',
    t70: 'B3',
    t80: 'CC',
    t90: 'E6',
    t100: 'FF',
  },
  input: {
    height: '40px',
    fontSize: '14px',
  },
};

export const GlobalStyles = createGlobalStyle`
  :root {
    --chat-widget-primary-color: ${({ theme }) => theme.primary};
    --chat-widget-active-color: ${({ theme }) => theme.primary};
    --chat-widget-bubble-color: ${({ theme }) => theme.primary};
  }

  html {
    background-color: #f9f4ee;
  }

  @font-face {
  font-family: 'SF Pro Display';
  src: url(${sfProDisplayRegular}) format('opentype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'SF Pro Display';
  src: url(${sfProDisplayMedium}) format('opentype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'SF Pro Display';
  src: url(${sfProDisplayBold}) format('opentype');
  font-weight: 700;
  font-style: normal;
}

  body {
    margin: 0;
    font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${(theme) => theme.white} !important;
    background-color: #f9f4ee;

    @media only screen and (max-width: 1920px) and (min-width: 800px) {
      /* zoom: 90%; */
    }


  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  img {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }

  * {
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  /*
   * Brand-colored focus ring.
   *
   * Uses :focus-visible (NOT :focus) so the ring only appears for
   * keyboard navigation, not on mouse clicks — mouse users don't get
   * the ring lingering on a button they just clicked, but Tab still
   * paints a clear focus outline.
   *
   * outline + outline-offset gives a clean ring that follows the
   * element's own border-radius.
   */
  :focus-visible {
    outline: 1px solid ${({ theme }) => theme.primary};
    outline-offset: 2px;
  }

  /*
   * Suppress the default browser focus ring for mouse clicks and
   * for elements that opted out (e.g. main content, modal container —
   * those use :focus { outline: none } locally to override).
   */
  :focus:not(:focus-visible) {
    outline: none;
  }

  ::-moz-selection {
    color: #fff;
    background: ${({ theme }) => theme.primary};
  }

  ::selection {
    color: ${(theme) => theme.white};
    background: ${({ theme }) => theme.primary}b2;
  }

  a:active {
    color: ${({ theme }) => theme.darkGray};
    text-decoration: none;
  }

  a:visited {
    color:  ${({ theme }) => theme.darkGray};
    text-decoration: none;
  }

  a:link {
    color:  ${({ theme }) => theme.darkGray};
    text-decoration: none;
  }

  .redSvgHover path {
    transition: all 0.2s ease-out;
  }

  .redSvgHover:hover path {
    fill: ${(theme) => theme.primary} !important;
  }

  .textHover {
    transition: color 0.2s ease !important;
  }

  .textHover:hover {
    color:${(theme) => theme.primary} !important;
  }

  /* .bottom {
  position: fixed;
  width: 100%;
  height: 10px;
  margin: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f9f4ee; /* Your color here */
} */

  .screen-reader-text {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clipPath: inset(50%);
  clipPath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  width: 1px;
  word-wrap: normal !important;
  word-break: normal;
}

  .tooltip-content {
    text-align: left;
    .wrap {
    max-width: 920px;
    margin: 0 auto;
  }
  h1 {
    font-size: 14px;
    font-weight: 700;
    color: var(--accent);
    margin: 0 0 4px 0;
  }
  .subtitle {
    font-size: 12px;
    color: var(--muted);
    margin-bottom: 12px;
  }
  .table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid var(--border);
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
  }
  .table th, .table td {
    padding: 5px 10px;
    border-bottom: 1px solid var(--border);
    vertical-align: top;
    font-size: 12px;
  }
  .table th {
    background: var(--header);
    text-align: left;
    font-weight: 700;
    font-size: 12px;
  }
  .table tr:last-child td {
    border-bottom: 0;
  }
  .note {
    font-size: 12px;
    color: var(--muted);
    margin-top: 12px;
    margin-bottom: 0;
  }

  /* Mobile stacking (optional) */
  /* @media (max-width: 640px) {
    .table thead {
      display: none;
    }
    .table, .table tbody, .table tr, .table td {
      display: block;
      width: 100%;
    }
    .table tr { border-bottom: 1px solid var(--border); }
    .table td {
      border: 0;
      padding: 10px 16px;
    }
    .table td::before {
      content: attr(data-label);
      display: block;
      font-weight: 600;
      color: var(--muted);
      margin-bottom: 4px;
    }
    .table tr:last-child { border-bottom: 0; }
  } */

`;
